export function formatDate(date: string, language: string | undefined): string {
  try {
    return new Intl.DateTimeFormat(language, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(date));
  } catch {
    return 'Invalid Date';
  }
}

export function getDateFormatPattern(language: string | undefined): string {
  const formatter = new Intl.DateTimeFormat(language);
  const parts = formatter.formatToParts(new Date());

  let pattern = '';
  parts.forEach(part => {
    if (part.type === 'month') pattern += 'MM';
    else if (part.type === 'day') pattern += 'dd';
    else if (part.type === 'year') pattern += 'yyyy';
    else pattern += part.value;
  });

  return pattern;
}
